function handleFirstTab(e) {
    if (e.keyCode === 9) { // tab
        document.body.classList.add('user-is-tabbing');
    }
}
window.addEventListener('keydown', handleFirstTab);
document.addEventListener("click", function(){
  document.body.classList.remove('user-is-tabbing');
});

var isiOS = false;
var agent = navigator.userAgent.toLowerCase();
if(agent.indexOf('iphone') >= 0 || agent.indexOf('ipad') >= 0){
	isiOS = true;
}
var globalCartJson;

var initializeCountdown = function(){var currentSeconds = new Date().getSeconds().toString();
    var now = Simplistic.strToDate(currentTime+":"+currentSeconds).getTime();
    var countDownDate = Simplistic.strToDate("2025-08-12 11:30:00").getTime();

    var x = setInterval(function() {
      var distance = countDownDate - now;
      // Time calculations for days, hours, minutes and seconds
      var days = Math.floor(distance / (1000 * 60 * 60 * 24));
      var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) + (days*24);
      hours = ('0'+hours).slice(-2);
      var minutes = ('0'+Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))).slice(-2);
      var seconds = ('0'+Math.floor((distance % (1000 * 60)) / 1000)).slice(-2);

      $('.status-bar .countdown:visible').html("<span>" + hours + "</span><span>:</span><span>" + minutes + "</span><span>:</span><span>" + seconds + "</span>");
      $('.status-bar .countdown:visible').addClass('initialized');

      if (distance < 0) {
        clearInterval(x);
        $('.status-bar .countdown').hide();
        $(document).trigger('refreshVariantStatus');
      }
      now = now + 1000;
      
      var tmpDate = new Date(now);
      currentTime = tmpDate.getFullYear() + '-' + ('0'+(tmpDate.getMonth()+1)).slice(-2) + '-' + ('0'+tmpDate.getDate()).slice(-2) + ' ' 
      	+ ('0'+tmpDate.getHours()).slice(-2) + ':' + ('0'+tmpDate.getMinutes()).slice(-2);
    }, 1000);};

var getServerDateTime = function(callback){
  if(typeof Shopify !== 'undefined' && !Shopify.designMode) {
    $.ajax({
      url: '/cart?view=datetime&cache=false'
    }).success(function(data){
      currentTime = data;
      callback();
    }).error(function(){
      callback();
    });
  } else {
  	callback();
  }
};

$(function() {
  	if(!isMobile.any) {
		$('body').addClass('isNotMobile');
  	}

  	$('.quantity').each(function(){
      	var wrapper = $(this);
		wrapper.find('.minus').click(function(){ 
          	try {
              wrapper.find('#quantity').get(0).stepDown();
            } catch(e) {
              var value = (parseInt(wrapper.find('#quantity').val())-1);
              wrapper.find('#quantity').val((value>=1 ? value : 1));
            }
            setTimeout(()=>{wrapper.find('#quantity').change()}, 100)
        });
        wrapper.find('.plus').click(function(){
          try {
          	wrapper.find('#quantity').get(0).stepUp();
          } catch(e) {
          	wrapper.find('#quantity').val((parseInt(wrapper.find('#quantity').val())+1));
          }
          setTimeout(()=>{wrapper.find('#quantity').change()}, 100)
        });  
  	});	
  
  	
      $('body').delegate('.add-to-cart-form', 'submit', function(){
        return validateAddCart($(this));
      });
  	
  
    function onscroll(){
      if($(window).scrollTop()<=200) {
        $('.scrollup').fadeOut();
      } else {
        $('.scrollup').fadeIn();
      }
      
      if($('.header-drop').length > 0){
        var showDH = $('#header').outerHeight();
        if($(window).scrollTop()>showDH) {
          $('.header-drop').addClass('active');
        } else {
          $('.header-drop').removeClass('active');
        }
      }
    }
    $(window).scroll(function(){
      onscroll();
    });
	onscroll();
  
  	$(document).on('click', '.size-chart-pop-up', function(){
    	Simplistic.openModal('<img src="'+$(this).attr('href')+'" alt="Contact customer service for assistance at info@steamandgo.com  or 818-818-6373." />', 'size-chart-modal');
      	return false;
    });
  
    $('.scrollto').click(function(){
      $.scrollTo($(this).attr('href'), 800, {offset: -70})
    });
  
    $('html').removeClass('no-js').addClass('js');
    setupDropdownMenus();

    $('.nav-arrow', '#top-menu').each( function(){
      $(this).css('top', Math.ceil($(this).parent(2).height()/2) + 1);
    });
  
    $(document).on('keypress', '[tabindex=0]:focus', function(event){
      var keycode = (event.keyCode ? event.keyCode : event.which);
      if(keycode == '13'){
        $(this).click(); 
      }
    });
  
  	$(document).on('click', '[data-popup]', function(){
      var popup = $($(this).data('popup'));
      popup.data('item', $(this).closest('.item'));
      Simplistic.openModal(popup);
    });
  
    $('.menu-mobile-trigger').click(function(){
      $(this).find('i').toggleClass('fa-navicon');
      $(this).closest('.any-header').find('.menu-container').toggleClass('open');
    });

    $('.menu-mobile .link button').click(function(){
      if($(this).closest('.link-inner').next('.submenu:first').length > 0){
        $(this).toggleClass('active');
        $(this).closest('.link-inner').next('.submenu:first').slideToggle(300);
      }
    });

  	/******************* BUTTONS ON GRID *******************/

  	$(document).on('click', '.product-item .add-button .btn.submit', function(){
      if(!$(this).hasClass('disabled')){
        $(this).closest('form').submit();
      }
      return false;
    });
	$(document).on('click', '.product-item .backorder-button .btn', function(){
      if(!$(this).hasClass('disabled')){
        var popup = $('.status-popup.backorder');
        var form = $(this).closest('form');
        popup.data('callback', function(){
          modal.close();
          form.submit();
        });
        Simplistic.openModal(popup);
      }
      return false;
    });

  	//Update server datetime and initialize the countdown for the onhold products
  	getServerDateTime(initializeCountdown);
});

function validateAddCart(form) {
  	var ok = true;
  	var errorMsg = '';
  	form.find('.error').removeClass('error');

  	if(form.find('input[name^=id]').val()=='') {
        var allOptionsSelected;
      	if(form.find('.single-option-selector').length > 0) {
            allOptionsSelected = true;
            form.find('.single-option-selector').each(function(){
                if($(this).val()=="") {
                  	$(this).addClass('error');
                    allOptionsSelected = false;
                    return false;
                }
            });
        } else {
          	allOptionsSelected = false;
        }
      	
      	if(allOptionsSelected) {
          	errorMsg = form.find('.validation-msg').text();
          	if(!errorMsg) {
              errorMsg = 'The selected variant is sold out.';
            }
        } else {
        	var labels = [];
            form.find('.variants-wrapper label:visible').each(function(key, obj){
              	$(this).parent().find('select, input').addClass('error');
                labels.push($.trim($(obj).text().replace(':', '')));
            });
          	errorMsg =  'You must select a '+labels.join('/');
        }
      	ok = false;
    }

  	if(ok) {
  		form.find('.required:visible').each(function(){
            if($(this).val()=='') {
                var labels = [];
                form.find('.properties label:visible').each(function(key, obj){
                    if($(this).next().hasClass('required')) {
                        $(this).parent().find('select, input').addClass('error');
                        labels.push($.trim($(obj).text().replace(':', '')));
                    }
                });

                errorMsg = 'You must enter '+labels.join('/');
                ok = false;
            }
        });
  	}
  
  	if(ok){
      form.find('[minlength]:visible').each(function(){
        var minlength = $(this).attr('minlength');
        if($(this).val().length < minlength) {
          $(this).parent().find('select, input').addClass('error');
          errorMsg = ($.trim($(this).parent().find('label').text().replace(':', '')))+' must have at least '+minlength+' chars.';
          ok = false;
        }
      });
    }
  
  	if(ok){
      form.find('[type="text"]:visible').each(function(key, obj){
        if(ok) {
          var name = $(this).attr('name');
          var label = $(obj).parent().find('label').text();
          if(form.find('[name="'+name+'"]:visible').length>1) {
            form.find('[name="'+name+'"]:visible').each(function(key2, obj2){
              if($(obj).val()!=$(obj2).val()) {
                $(this).parent().find('select, input').addClass('error');
                errorMsg = ($.trim(label.replace(':', '')))+' must match with its confirmation.';
                ok = false;
              }
            });
          }
        }
      });
    }
  
  	if(!ok) {
      $('#notification-bar').removeClass('ok').html(errorMsg + '<svg version="1.1" x="0px" y="0px" width="20.5px" height="20.25px" viewBox="0 0 20.5 20.25" class="error-cross"><line fill="none" stroke="#FFFFFF" stroke-width="3" stroke-miterlimit="10" x1="1.234" y1="1.12" x2="19.277" y2="19.163"/><line fill="none" stroke="#FFFFFF" stroke-width="3" stroke-miterlimit="10" x1="19.277" y1="1.12" x2="1.234" y2="19.163"/></svg>').addClass('error active');

      var timeout = $('#notification-bar').data('timeout');
      if(timeout) {
        clearTimeout(timeout);
      }
      timeout = setTimeout(function(){
      	$('#notification-bar').removeClass('active');
      }, 4000);
      $('#notification-bar').data('timeout', timeout);
    }
  	return ok;
}

/**
 * Support for dropdown menus
 */
function setupDropdownMenus(){
	$('.main-menu .has-dropdown').hoverIntent( navRollOver, navRollOut );

	function navRollOver(e){
		$(this).addClass('active').find('.submenu:first').slideDown();
	}
	function navRollOut(e){
		$(this).removeClass('active').find('.submenu:first').slideUp();
	}
}

function showAddButtonLoading(form) {
	form.find('input[type="submit"]').attr('disabled', 'disabled');
    form.find('.loader').show().addClass('active');
}

function showAddButtonOriginal(form) {
	if(!form.find('input[type="submit"]').hasClass('disabled')) {
      form.find('input[type="submit"]').attr('disabled', false);
    }
  	form.find('.loader').hide().removeClass('active');
}

/**
 * Ajaxy add-to-cart
 */
function addToCart(form){
    showAddButtonLoading(form);
  
  	var add = function() {
  		$.ajax({
          type: 'POST',
          url: '/cart/add.js',
          cache: false,
          data: form.serialize(),
          dataType: 'json',
          error: function(jqXHR, textStatus, errorThrown){
            addToCartFail(form, jqXHR, textStatus, errorThrown)
          },
          success: function(jqXHR, textStatus, errorThrown){
            addToCartSuccess(form, jqXHR, textStatus, errorThrown)
          },
          cache: false
        });
  	}
  
  	if(settings.limit != 'No limit') {
    	updateCartDesc(function(){
            if(!form.find('.add-button input').hasClass('disabled')) { //If there is no limit errors
				add();
            } else {
                showAddButtonOriginal(form);
            }
        });
    } else {
    	add();
    }
}

function addToCartSuccess(form, jqXHR, textStatus, errorThrown){
  	updateCartDesc(function(){
    	showAddButtonOriginal(form);

      	
            $('#notification-bar').removeClass('error').html('<span>Item Added! <svg height="32px" viewBox="0 0 32 32" class="checkmark"><path fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path></svg></span><a href="/cart"><div class="btn animated fadeInLeft">Proceed to Checkout <i class="fa fa-arrow-right"></i></div></a>').addClass('ok active');
      		setTimeout(function(){
              $('.main-menu .cart-normal').addClass('animated rubberBand');
            }, 1000);
      
      		var timeout = $('#notification-bar').data('timeout');
      		if(timeout) {
              clearTimeout(timeout);
            }
            timeout = setTimeout(function(){
              $('#notification-bar').removeClass('active');
              $('.main-menu .cart-normal').removeClass('animated rubberBand');
            }, 4000);
      		$('#notification-bar').data('timeout', timeout);
        
    });
}

function addToCartFail(form, jqXHR, textStatus, errorThrown){
  	showAddButtonOriginal(form);  
  
  	var response = $.parseJSON(jqXHR.responseText);
	$('#add-to-cart-msg').addClass('error').text(response.description).fadeIn('fast');
  	$('#add-cart-overlay').fadeOut();
  
  	$('#notification-bar').removeClass('ok').html(response.description + '<svg version="1.1" x="0px" y="0px" width="20.5px" height="20.25px" viewBox="0 0 20.5 20.25" class="error-cross"><line fill="none" stroke="#FFFFFF" stroke-width="3" stroke-miterlimit="10" x1="1.234" y1="1.12" x2="19.277" y2="19.163"/><line fill="none" stroke="#FFFFFF" stroke-width="3" stroke-miterlimit="10" x1="19.277" y1="1.12" x2="1.234" y2="19.163"/></svg>').addClass('error active');
    var timeout = $('#notification-bar').data('timeout');
    if(timeout) {
      clearTimeout(timeout);
    }
    timeout = setTimeout(function(){
      $('#notification-bar').removeClass('active');
    }, 4000);
    $('#notification-bar').data('timeout', timeout);
}

function removeItemToCart(variantId){
  	$('#add-cart-overlay').fadeIn();

	$.ajax({
		type: 'POST',
		url: '/cart/change.js',
      	data: {
          id: variantId,
          quantity: 0
        },
		dataType: 'json',
      	error: function(){
      		$('#add-cart-overlay').fadeOut();
      	},
      	success: function(){
          	updateCartDesc();
      		$('#add-cart-overlay').fadeOut();
      	},
		cache: false
	});
}

function updateCartDesc(callback){
  	$.ajax({
		type: 'GET',
		url: '/cart?view=json',
		//async: false,
		cache: false,
      	success: function(cart){
          //This replace is for the theme editor preview
          cart = cart.replace('<!-- BEGIN template --><!-- cart.json -->', '');
          cart = cart.replace('<!-- END template -->', '');
          cart = $.trim(cart);
          cart = JSON.parse(cart);
          globalCartJson = cart;
          var totalPrice = (Shopify.formatMoney ? Shopify.formatMoney(cart.total_price, formatMoney) : (cart.total_price/100).toString()).replace('.00', '').replace(' ', '');
          $('.cart-fixed sup').html(cart.item_count);
          $('#view-cart-normal sup').html(cart.item_count);
          $('#view-cart-normal .cart-total-price sup').html(totalPrice);
          if(cart.item_count > 0) {
          	$('#view-cart-normal .cart-total-price').css('display','block');                                           
            $('.cart-fixed span').show();
          }
          
          if($('.templateProduct').length > 0) {
          	//This is to show the confirmation in the button (product page). The problem with this
            // is that a customer can add more products than the limit
            /*setTimeout(function(){
              refreshLimits(cart);
            }, 5000);*/
            refreshLimits(cart);
          } else {
            refreshLimits(cart);
          }
          
          if(callback) {
          	callback();
          }
    	}
	});
}

window.emojiStrip=function(u){function D(E){if(F[E])return F[E].exports;var C=F[E]={i:E,l:!1,exports:{}};return u[E].call(C.exports,C,C.exports,D),C.l=!0,C.exports}var F={};return D.m=u,D.c=F,D.i=function(u){return u},D.d=function(u,F,E){D.o(u,F)||Object.defineProperty(u,F,{configurable:!1,enumerable:!0,get:E})},D.n=function(u){var F=u&&u.__esModule?function(){return u.default}:function(){return u};return D.d(F,"a",F),F},D.o=function(u,D){return Object.prototype.hasOwnProperty.call(u,D)},D.p="",D(D.s=1)}([function(u,D,F){"use strict";u.exports=function(){ return /\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74|\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67)\uDB40\uDC7F|(?:\uD83E\uDDD1\uD83C\uDFFF\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFF\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFE])|(?:\uD83E\uDDD1\uD83C\uDFFE\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFE\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFD\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFD\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFC\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFC\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|(?:\uD83E\uDDD1\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1|\uD83D\uDC69\uD83C\uDFFB\u200D\uD83E\uDD1D\u200D(?:\uD83D[\uDC68\uDC69]))(?:\uD83C[\uDFFC-\uDFFF])|\uD83D\uDC68(?:\uD83C\uDFFB(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFC-\uDFFF])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))?|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFF]))|\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFE])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83E\uDD1D\u200D\uD83D\uDC68(?:\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])\uFE0F|\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC)?|(?:\uD83D\uDC69(?:\uD83C\uDFFB\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|(?:\uD83C[\uDFFC-\uDFFF])\u200D\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69]))|\uD83E\uDDD1(?:\uD83C[\uDFFB-\uDFFF])\u200D\uD83E\uDD1D\u200D\uD83E\uDDD1)(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC69(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83E\uDDD1(?:\u200D(?:\uD83E\uDD1D\u200D\uD83E\uDDD1|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFF\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFE\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFD\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFC\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD])|\uD83C\uDFFB\u200D(?:\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E[\uDDAF-\uDDB3\uDDBC\uDDBD]))|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83E\uDDD1(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDC69(?:\uD83C\uDFFF\u200D[\u2695\u2696\u2708]|\uD83C\uDFFE\u200D[\u2695\u2696\u2708]|\uD83C\uDFFD\u200D[\u2695\u2696\u2708]|\uD83C\uDFFC\u200D[\u2695\u2696\u2708]|\uD83C\uDFFB\u200D[\u2695\u2696\u2708]|\u200D[\u2695\u2696\u2708])|\uD83D\uDE36\u200D\uD83C\uDF2B|\uD83C\uDFF3\uFE0F\u200D\u26A7|\uD83D\uDC3B\u200D\u2744|(?:(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\uD83C\uDFF4\u200D\u2620|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])\u200D[\u2640\u2642]|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u3030\u303D\u3297\u3299]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]|\uD83D[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])\uFE0F|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83D\uDE35\u200D\uD83D\uDCAB|\uD83D\uDE2E\u200D\uD83D\uDCA8|\uD83D\uDC15\u200D\uD83E\uDDBA|\uD83E\uDDD1(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83D\uDC69(?:\uD83C\uDFFF|\uD83C\uDFFE|\uD83C\uDFFD|\uD83C\uDFFC|\uD83C\uDFFB)?|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83C\uDDF4\uD83C\uDDF2|\uD83D\uDC08\u200D\u2B1B|\u2764\uFE0F\u200D(?:\uD83D\uDD25|\uD83E\uDE79)|\uD83D\uDC41\uFE0F|\uD83C\uDFF3\uFE0F|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\u2764\uFE0F|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF4|(?:[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270C\u270D]|\uD83D[\uDD74\uDD90])(?:\uFE0F|\uD83C[\uDFFB-\uDFFF])|[\u270A\u270B]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC08\uDC15\uDC3B\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE2E\uDE35\uDE36\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD0C\uDD0F\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5]|\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC70\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD35\uDD37-\uDD39\uDD3D\uDD3E\uDDB8\uDDB9\uDDCD-\uDDCF\uDDD4\uDDD6-\uDDDD]|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF]|[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED7\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB]|\uD83E[\uDD0D\uDD0E\uDD10-\uDD17\uDD1D\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78\uDD7A-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCB\uDDD0\uDDE0-\uDDFF\uDE70-\uDE74\uDE78-\uDE7A\uDE80-\uDE86\uDE90-\uDEA8\uDEB0-\uDEB6\uDEC0-\uDEC2\uDED0-\uDED6]/g}},function(u,D,F){function E(u){return u.replace(A,"")}var C=F(0),A=C();u.exports=E}]);
        
function refreshLimits(cart) {
  if(settings.limit != 'No limit') {
    $('[id*=product-item-]').each(function(){
      var item = $(this);
      var productId = item.data('product-id');
      var productHandle = item.data('product-handle').toString().replace('-backorder', '');
      var qtyAvailable = 0;

      //Limit per product
      if(settings.limit_per == 'product') {
        var itemCount = 0;
        $.each(cart.items, function(){
          var cartItemHandle = this.item.handle.toString().replace('-backorder', '');
          if(cartItemHandle == productHandle) {
            itemCount += this.item.quantity;
          }
        });
        qtyAvailable = settings.limit_quantity - itemCount;
      }
      
      //Limit per order
      if(settings.limit_per == 'order') {
        qtyAvailable = settings.limit_quantity - cart.item_count;
      }
      
      //Limit per category
      if(settings.limit_per == 'category') {
        qtyAvailable = 9999;
        var categoryLimits = settings.limit_categories.split(',');
        $.each(categoryLimits, function(key, categoryLimit){
          	var categoryLimitArr = categoryLimit.split(':');
          	var categoryTag = categoryLimitArr[0];
          	var categoryQty = categoryLimitArr[(categoryLimitArr.length - 1)];
          	if(item.data('product') && item.data('product').tags.indexOf(categoryTag)>=0) {
              	var itemCount = 0;
              	$.each(cart.items, function(key, cartItem){
                  if(cartItem.product.tags.indexOf(categoryTag)>=0) {
                  	itemCount += cartItem.item.quantity;
                  }
                });
              	if(qtyAvailable > (categoryQty-itemCount)) {
                    qtyAvailable = categoryQty - itemCount;
                }
            }
        });
      }

      if(qtyAvailable <= 0) {
        item.find('.btn').addClass('disabled').attr('disabled', 'disabled');
        item.find('.product-content').hide(); //Main product
        item.find('.product-limit-msg').show(); //Main product
      } else {
        item.find('.btn').removeClass('disabled').attr('disabled', false);
        item.find('.product-content').show(); //Main product
        item.find('.product-limit-msg').hide(); //Main product
      }

      //Update the select quantities
      var selectQty = item.find('select[name="quantity"]');
      if(selectQty.length > 0) {
      	var selectedValue = selectQty.val();
        selectQty.find('option').remove();
        for(var i=1; i<=qtyAvailable; i++) {
          selectQty.append('<option value="'+i+'">' + i + '</option>');
        }
        selectQty.val(selectedValue);
      }

    });
    if(settings.limit!='No limit' && settings.limit_per=='order' && cart.item_count>=settings.limit_quantity) {
      $('.grid-limit-msg').removeClass('hide');
    } else {
      $('.grid-limit-msg').addClass('hide');
    }
  } else {
    $('#product-wrap .product-content').show(); //Main product
  }
  $('#collection-grid .item .buttons-wrapper').show(); //Grid
}

window.SimplisticJS = function (){
  this.formatMoney = "$ \{\{amount\}\}";
  
  this.handleize = function (str) {
    //source https://gist.github.com/dlindenkreuz/a439ec4b939f0561d6d9
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  };

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.trapFocus = function(options) {
    this.beforeTrapFocus = $(':focus');
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (
        options.$container[0] !== evt.target &&
        !options.$container.has(evt.target).length
      ) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  this.removeTrapFocus = function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }
    if(this.beforeTrapFocus) {
    	this.beforeTrapFocus.focus();
      	this.beforeTrapFocus = false;
    }

    $(document).off(eventName);
  }

  this.getQueryParam = function(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  this.randomstring = function(L){
    var s= '';
    var randomchar=function(){
      var n= Math.floor(Math.random()*62);
      if(n<10) return n; //1-10
      if(n<36) return String.fromCharCode(n+55); //A-Z
      return String.fromCharCode(n+61); //a-z
    }
    while(s.length< L) s+= randomchar();
    return s;
  }

  this.validateEmail = function(email) {
    var re = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
    return re.test(email);
  }

  this.openModal = function(content, css) {
    modal = new tingle.modal({
      closeMethods: ['overlay', 'button', 'escape'],
      closeLabel: "Close",
      cssClass: [css]
    });
    modal.setContent(content);
    modal.open();
  }

  this.onImagesLoaded = function(images, callback){
    var imagesLoaded = 0;
    images.each(function(){
      var img = new Image();
      img.onload = function() {
        imagesLoaded++;
        if(imagesLoaded==images.length) {
          callback();
        }
      };
      img.src = $(this).attr('src');
    });
  };
  
  this.strToDate = function(str){
  	var date = str.split(" ")[0].split('-');
    var time = str.split(" ")[1].split(':');
    
    var year = date[0];
    var month = parseInt(date[1])-1;
    var day = date[2];
    var hour = time[0];
    var min = time[1];
    var sec = time[2];
    
    return new Date(year, month, day, hour, min, sec);
  }

  this.showNotificationBarSuccess = function(text) {
  	this.showNotificationBar(text, 'success');
	}

	this.showNotificationBarError = function(text) {
  	this.showNotificationBar(text, 'error');
	}

  this.showNotificationBar = function(text, type) {
  	if(type=="success") {
			$('#notification-bar').removeClass('error').html(text + '<svg height="32px" viewBox="0 0 32 32" class="checkmark"><path fill="none" stroke="#ffffff" stroke-width="3" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path></svg>').addClass('ok active');
  	} else {
  		$('#notification-bar').removeClass('ok').html(text + '<svg version="1.1" x="0px" y="0px" width="20.5px" height="20.25px" viewBox="0 0 20.5 20.25" class="error-cross"><line fill="none" stroke="#FFFFFF" stroke-width="3" stroke-miterlimit="10" x1="1.234" y1="1.12" x2="19.277" y2="19.163"/><line fill="none" stroke="#FFFFFF" stroke-width="3" stroke-miterlimit="10" x1="19.277" y1="1.12" x2="1.234" y2="19.163"/></svg>').addClass('error active');
  	}
		var timeout = $('#notification-bar').data('timeout');
		if(timeout) {
		  clearTimeout(timeout);
		}
		timeout = setTimeout(function(){
		  $('#notification-bar').removeClass('active');
		}, 4000);
		$('#notification-bar').data('timeout', timeout);
	}
};
window.Simplistic = new SimplisticJS();